import { getInstance } from "../auth";
import { watch } from 'vue'


const state = {
  token: null,
  expiration: null
};

const getters = {
  token(state) {
    return state.token;
  }
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  }
};

const actions = {
    retrieveTokenFromAuthz(context) {
        return new Promise((resolve, reject) => {
            const instance = getInstance();
            const unwatch =  watch(() => instance.loading, (loading) => {
                if (loading === false) {
                    if (instance.isAuthenticated) {
                        instance
                            .getTokenSilently()
                            .then(authToken => {
                                context.commit("setToken", authToken);
                                localStorage.setItem("auth_token", authToken);
                                resolve({ authToken });
                            })
                            .catch(error => reject(error));
                    } else {
                        resolve({ authToken: null });
                    }
                    // Stop watching après le premier trigger
                    if (unwatch) unwatch();
                }
            });

            // Si pas de $watch, fallback avec polling
            if (!instance.$watch) {
                const interval = setInterval(() => {
                    if (instance.loading === false) {
                        clearInterval(interval);
                        if (instance.isAuthenticated) {
                            instance
                                .getTokenSilently()
                                .then(authToken => {
                                    context.commit("setToken", authToken);
                                    localStorage.setItem("auth_token", authToken);
                                    resolve({ authToken });
                                })
                                .catch(error => reject(error));
                        } else {
                            resolve({ authToken: null });
                        }
                    }
                }, 100);
            }
        });
    }
};
export const auth0 = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};